import { GetTrainingsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface Props {
  ids?: number[]
  catalog?: boolean
  returnExpiredMemberships?: boolean
}

export const useTrainings = ({ ids, catalog, returnExpiredMemberships }: Props) => {
  const { loading, data, error } = useQuery(GetTrainingsDocument, {
    variables: { ids, catalog, returnExpiredMemberships },
  })

  return {
    error,
    loading,
    trainings: data ? data.trainings.trainingsConnection.nodes : undefined, // Provide a default value
  }
}
